import { asyncComponent } from 'react-async-component';

export default asyncComponent({
  name: 'ImageCroppingOverlayAsyncNext',
  resolve: () =>
    import(
      /* webpackChunkName: "ImageCroppingOverlayAsyncNext" */ './Overlay.next'
    )
});
